import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export const SwitchViewButton = (props: any) => (
  <SvgIcon {...props}>
    <path d="M0 0L5 5L10 0H0Z" fill="#3D5E7B" />
  </SvgIcon>
);
